enum Visibility {
    Always = 'alw',
    WithStock = 'wtstk',
    Hidden = 'hid',
}

export default Visibility;
